var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Children, Component } from 'react';
import { Direction } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType, Container } from '@philips-internal/oswald-ui-core';
import { arrayOf, expression, formatters as formatterProps, number, object, oneOf, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { classNames, enumValues, isValidWidth, propagateData } from '@philips-internal/oswald-ui-utils';
import PseudonymAppointmentSuggestionResumeCard from './pseudonym-appointment-suggestion-resume-card/pseudonym-appointment-suggestion-resume-card';
import './pseudonym-appointment-suggestion-card.css';
import { PseudonymAppointmentSuggestionCardAPI } from '.';
import { EditorContext } from '@philips-internal/oswald-ui-core/lib/component';
const acceptedTypes = [
    ComponentType.BEHAVIOR,
    ComponentType.LIST,
];
let PseudonymAppointmentSuggestionCard = class PseudonymAppointmentSuggestionCard extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            open: false,
        };
        this.onCardClick = () => {
            this.setState((prevState) => ({ open: !prevState.open }));
        };
    }
    static { this.contextType = EditorContext; }
    static { this.propTypes = {
        consultationLocation: expression,
        direction: oneOf(enumValues(Direction)),
        events: arrayOf(object).notEnumerable(),
        filterParameter: expression,
        formatters: formatterProps,
        id: string,
        suggestions: arrayOf(object).notEnumerable(),
        uuid: string,
        width: number,
    }; }
    static { this.defaultProps = {
        direction: Direction.HORIZONTAL,
        suggestions: [],
        width: 12,
    }; }
    renderSearchResultCard() {
        const { events, suggestions, consultationLocation, filterParameter, direction, } = this.props;
        return (React.createElement(PseudonymAppointmentSuggestionResumeCard, { consultationLocation: consultationLocation, direction: direction, events: events, filterParameter: filterParameter, numberOfSuggestions: ('0' + suggestions.length).slice(-2), onClick: this.onCardClick, open: this.state.open }));
    }
    renderSuggestions() {
        const { children, suggestions } = this.props;
        const { open } = this.state;
        if (!open || !Array.isArray(suggestions) || !children) {
            return null;
        }
        return (React.createElement("div", { className: "c-pseudonym-appointment-suggestion-card__expandable-area" }, propagateData(children, suggestions)));
    }
    renderContainer() {
        const { uuid, children } = this.props;
        if (!this.context?.isDesigning() || Children.count(children)) {
            return null;
        }
        return (React.createElement(Container, { acceptedTypes: acceptedTypes, uuid: uuid, repeated: true }));
    }
    getClassNames() {
        const { width } = this.props;
        return classNames({
            'c-pseudonym-appointment-suggestion-card': true,
            [`u-grid-col-${width}`]: isValidWidth(width),
        });
    }
    render() {
        return (React.createElement("div", { className: this.getClassNames() },
            this.renderSearchResultCard(),
            this.renderSuggestions(),
            this.renderContainer()));
    }
};
PseudonymAppointmentSuggestionCard = __decorate([
    AwesomeComponent({ api: PseudonymAppointmentSuggestionCardAPI, type: ComponentType.DATA_DISPLAY })
], PseudonymAppointmentSuggestionCard);
export default PseudonymAppointmentSuggestionCard;
//# sourceMappingURL=pseudonym-appointment-suggestion-card.js.map